import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["slideAlign", "slideWidth"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import CustomPropTypes from '../../util/custom-prop-types';
import { StyledCarouselSlide } from './CarouselSlide.styles';

/**
 * Wrapper for a piece of content displayed in a `Carousel`.
 *
 * @extends Flex
 * @since 8.71.0
 */
export var CarouselSlide = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var slideAlign = _ref.slideAlign,
    slideWidth = _ref.slideWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledCarouselSlide, _extends({
    as: "li",
    slideAlign: slideAlign,
    slideWidth: slideWidth,
    ref: forwardedRef
  }, rest));
});
CarouselSlide.displayName = 'CarouselSlide';
CarouselSlide.propTypes = {
  /**
   * Determines how a slide should try to align within its container. Applied using
   * [`scroll-snap-align`](https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-snap-align).
   */
  slideAlign: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['start', 'end', 'center'])),
  /**
   * Sets the width of a slide using `flex-basis`. Takes a number or the,
   * default, `auto`.
   *
   * Supports inline media query objects.
   */
  slideWidth: CustomPropTypes.inlineMediaQuery(PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]))
};
CarouselSlide.defaultProps = {
  slideAlign: 'start',
  slideWidth: 'auto'
};